import { IonRouterLink } from '@ionic/react';
import { FormattedMessage, useIntl } from 'react-intl';

import ExpandableSection from '@components/animations/ExpandableSection';
import TertiaryButton from '@components/buttons/TertiaryButton';
import StageForm from '@components/forms/StageForm';
import Modal from '@components/Modal';
import styles from '@components/profile/Profile.module.css';
import StageInfo from '@components/StageInfo';
import Icon from '@components/text/Icon';
import Heading2 from '@components/typography/Heading2';
import useOpener from '@hooks/useOpener';
import { CareProfileAgeEnum, GetJourneyWithCareProfileQuery } from '@typing/Generated';

type Props = {
  journey: GetJourneyWithCareProfileQuery['journey'];
};

const Stage = ({ journey }: Props) => {
  const opener = useOpener();
  const intl = useIntl();

  const stageFormOpener = useOpener();

  return (
    <div>
      <IonRouterLink onClick={opener.toggle}>
        <div className={styles.section}>
          <Heading2>
            <FormattedMessage id="pages.client.careProfile.sections.stage" />
          </Heading2>
          <Icon
            ariaLabelKey="accessibility.ariaLabels.toggle"
            className={styles.toggleOpener}
            icon={opener.isOpen ? 'chevronUp' : 'chevronDown'}
          />
        </div>
      </IonRouterLink>
      <ExpandableSection isOpen={opener.isOpen}>
        {journey.careProfile.age !== CareProfileAgeEnum.deceased && (
          <div className={styles.end}>
            <TertiaryButton icon="edit" onClick={stageFormOpener.open} textKey="dictionary.edit" />
          </div>
        )}
        <StageInfo stage={journey.stage} />
      </ExpandableSection>
      <Modal
        opener={stageFormOpener}
        title={intl.formatMessage({
          id: 'pages.careJourney.editStage'
        })}
      >
        {() => <StageForm journey={journey} onCancel={stageFormOpener.close} onSuccess={stageFormOpener.close} />}
      </Modal>
    </div>
  );
};

export default Stage;
